"use client";

import { Button } from "@/components/Button";
import { NewspaperIcon } from "@heroicons/react/24/outline";
import React from "react";

export const Subscribe = () => {
  const [loading, setLoading] = React.useState(false);
  const [result, setResult] = React.useState<{
    message?: string;
    error?: string;
  } | null>(null);

  if (result?.message) {
    return (
      <span>
        <p className="mb-0 mt-4 inline-flex rounded-md border border-primary-500/30 bg-primary-500/5 px-3 py-2.5 text-[13px] text-primary-400">
          Thank you for subscribing!
        </p>
      </span>
    );
  }

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        setLoading(true);
        setResult(null);
        try {
          const formData = new FormData(e.target as HTMLFormElement);
          const res = await fetch("/api/subscribe", {
            method: "POST",
            body: JSON.stringify({
              email: formData.get("email"),
            }),
          }).then((res) => res.json());
          setResult(res);
        } catch (error) {
          setResult({ error: "Failed to subscribe. Please try again." });
        } finally {
          setLoading(false);
        }
      }}
      className="mt-4 flex flex-col items-start gap-y-2"
    >
      <div className="focus-within:outline-default inline-flex rounded-lg border border-neutral-700/50 bg-neutral-900 text-sm shadow-sm shadow-black/40">
        <input
          type="email"
          name="email"
          placeholder="Your email address"
          className="min-w-[200px] appearance-none rounded-md border-0 bg-transparent bg-clip-text px-3 py-2.5 text-sm !ring-transparent transition-[background-color] duration-[5000s] placeholder:text-neutral-500 autofill:bg-transparent autofill:text-sm autofill:[-webkit-text-fill-color:white] focus:border-0 focus:!outline-none"
        />
        <Button
          className="bg-btn-primary my-1 mr-1 rounded-md border border-transparent p-1 px-4 text-[13px] font-semibold text-white shadow-sm shadow-black/40"
          disabled={loading}
        >
          {loading ? "Subscribing..." : "Subscribe"}
        </Button>
      </div>
      {result?.error && !loading && (
        <div className="text-sm text-red-500">{result.error}</div>
      )}
    </form>
  );
};

export const SubscribeCard = ({ children }) => {
  return (
    <div className="glow not-prose borde rounded-lg p-6">
      <div className="flex items-center gap-x-2">
        <NewspaperIcon className="size-5 text-neutral-500" />
        <h3 className="mb-0 mt-0 font-semibold">Stay up to date</h3>
      </div>
      <p className="mt-2 text-sm text-gray-400">
        Subscribe to our newsletter to get the latest (but infrequent) updates
        delivered to your inbox.
      </p>
      {children}
    </div>
  );
};
